module.exports = __webpack_public_path__ + "ws.svg?b8c5100b3784c0d3bd334f5e9a24323d";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ws.svg
// module id = 977
// module chunks = 27